import { Injectable } from "@angular/core";
import { ConsumerService } from "../../shared/services/consumer.service";
import { Observable } from "rxjs";
import { Response } from "../../shared/models/response";
import { Country } from "../../shared/models/country";
import { Bank } from "../../shared/models/bank";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class ObsicashOnboardingService {
  constructor(private consumerService: ConsumerService) {}

  getRegisteredIdentifications(request): Observable<Response> {
    return this.consumerService.post(
      environment.jweUrls.URL_POST_OBSICASH_IDENTIFICATION_REGISTER,
      request
    );
  }

  getAdditionalData(country, project): Observable<Response> {
    return this.consumerService.get(
      environment.jweUrls.URL_GET_OBSICASH_ONBOARDING_ADDITIONAL_DATA.url,
      project + "/" + country
    );
  }

  getAccountBanks(request: string): Observable<Response> {
    return this.consumerService.post(
      environment.jweUrls.URL_POST_OBSICASH_ACCOUNT_BANK,
      request
    );
  }

  sendCountryPending(req): Observable<Response> {
    return this.consumerService.put(
      environment.jweUrls.URL_POST_OBSICASH_SEND_COUNTRY_PENDING.url,
      req
    );
  }

  onboarding(req) {
    return this.consumerService.put(
      environment.jweUrls.URL_POST_OBSICASH_ONBOARDING_UPTADE.url,
      req
    );
  }
  onboardingDidi(req) {
    return this.consumerService.put(
      environment.jweUrls.URL_POST_OBSICASH_ONBOARDING_DIDI_UPDATE.url,
      req
    );
  }

  getServiceTermsConditions(type, language) {
    return this.consumerService.get(
      environment.jweUrls.URL_GET_STATIC_CONTENT.url,
      "?type=" + type.name,
      "NA",
      language
    );
  }

  SetStage(req): Observable<Response> {
    return this.consumerService.put(
      environment.jweUrls.URL_POST_OBSICASH_ONBOARDING_SET_STAGE.url,
      req
    );
  }

  deleteAllUserRecords(req): Observable<Response> {
    return this.consumerService.put(
      environment.jweUrls.URL_DELETE_OBSICASH_ONBOARDING_DELETE_ALL_USER_RECORDS
        .url,
      req
    );
  }

  getStates(req): Observable<Response> {
    return this.consumerService.put(
      environment.jweUrls.URL_POST_OBSICASH_SEND_STATES.url,
      req
    );
  }
  getServiceTermsConditionsBB(type, language) {
    return this.consumerService.get(
      environment.jweUrls.URL_GET_STATIC_CONTENT_BLUE_BANK.url,
      "?type=" +
        type.name +
        "&bankId=" +
        type.bankId +
        "&projectId=" +
        type.projectId +
        "&status=0",
      "NA",
      language
    );
  }
  //  get-content-proj-bank?type=TERMS_OF_SERVICES&bankId=10000&projectId=10000&status=0
}
